__turbopack_context__.v({
  "caption": "ADL_4a_caption" + " " + __turbopack_context__.i(515534)["sectionLabel"],
  "card": "ADL_4a_card",
  "cardBodyText": "ADL_4a_cardBodyText" + " " + __turbopack_context__.i(515534)["cardBody"],
  "cardHeading": "ADL_4a_cardHeading" + " " + __turbopack_context__.i(515534)["cardTitle"],
  "cardImageWrapper": "ADL_4a_cardImageWrapper",
  "cardTextBlock": "ADL_4a_cardTextBlock",
  "cardVideo": "ADL_4a_cardVideo",
  "carouselWrapper": "ADL_4a_carouselWrapper",
  "controls": "ADL_4a_controls",
  "dot": "ADL_4a_dot",
  "emblaContainer": "ADL_4a_emblaContainer",
  "emblaSlide": "ADL_4a_emblaSlide",
  "emblaViewport": "ADL_4a_emblaViewport",
  "navButtonWrapper": "ADL_4a_navButtonWrapper",
  "section": "ADL_4a_section",
  "sectionContent": "ADL_4a_sectionContent",
  "sectionDesc": "ADL_4a_sectionDesc",
  "sectionTitle": "ADL_4a_sectionTitle" + " " + __turbopack_context__.i(515534)["sectionHeading"],
  "webGLBackground": "ADL_4a_webGLBackground",
});
